import { Box, Card, CardContent, Skeleton, Stack, Divider } from '@mui/material';
import { Container } from '../../../components/container';

export const SettingsSkeleton = () => (
  <Container>
    <Box sx={{ mb: 4 }}>
      <Skeleton variant="text" width={150} height={40} />
    </Box>

    <Stack spacing={3}>
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Box>
              <Skeleton variant="text" width={120} height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" width={200} height={20} />
            </Box>
            <Skeleton variant="rounded" width={60} height={34} />
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Box>
              <Skeleton variant="text" width={100} height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" width={180} height={20} />
            </Box>
            <Skeleton variant="rounded" width={120} height={40} />
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Skeleton variant="text" width={140} height={24} sx={{ mb: 2 }} />

          <Box sx={{ mb: 2 }}>
            <Skeleton variant="text" width={80} height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rounded" width="100%" height={40} />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Skeleton variant="text" width={60} height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rounded" width="100%" height={40} />
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Skeleton variant="rounded" width={100} height={36} />
            <Skeleton variant="rounded" width={80} height={36} />
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Skeleton variant="text" width={120} height={24} sx={{ mb: 2 }} />

          <Stack spacing={2}>
            {[1, 2, 3].map((index) => (
              <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Skeleton variant="text" width={150} height={20} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width={220} height={16} />
                </Box>
                <Skeleton variant="rounded" width={50} height={30} />
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Skeleton variant="text" width={160} height={24} sx={{ mb: 2 }} />

          <Stack spacing={2}>
            <Box>
              <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
              <Skeleton variant="rounded" width={200} height={40} />
            </Box>

            <Box>
              <Skeleton variant="text" width={140} height={20} sx={{ mb: 1 }} />
              <Skeleton variant="rounded" width="100%" height={100} />
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ display: 'flex', gap: 2 }}>
              <Skeleton variant="rounded" width={120} height={36} />
              <Skeleton variant="rounded" width={100} height={36} />
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  </Container>
);
